import Vue from "vue";
import Vuex from "vuex";
import axios from "@/directives/axios.js";

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  const token = getCookie("catecumen_token"); // Obtén la cookie que contiene el token

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`; // Agrega el token al encabezado
  }

  return config;
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    listaColegios: undefined,
    listaCursosEscolares: undefined,
    listaPadres: undefined,
    listaMadres: undefined,
    listaCursosGruposCatequistas: undefined,
    listaPadresHijos: undefined,
    listaMadresHijos: undefined,
    listaCatequistasSimple: undefined,
    listaCursos: undefined,
    listaCatecumenosPadres: undefined,
    CursosGruposNum: undefined,
    datosUsuario: undefined,

    litaCursosCatequesis: [],

    privilegiosUsuario: [],
    tipoPrivilegiosUsuario: undefined,
  },
  getters: {
    getPrivilegiosUsuario(state) {
      return state.privilegiosUsuario;
    },
    getDatosUsuario(state) {
      return state.datosUsuario;
    },
    getCursosGruposNum(state) {
      return state.CursosGruposNum;
    },
    getListaCatecumenosPadres(state) {
      return state.listaCatecumenosPadres;
    },
    getTodosCatequistasSimple(state) {
      return state.listaCatequistasSimple;
    },
    getCursos(state) {
      return state.listaCursos;
    },
    getColegios(state) {
      return state.listaColegios;
    },
    getCursosEscolares(state) {
      return state.listaCursosEscolares;
    },
    getCursosGruposCatequistas(state) {
      return state.listaCursosGruposCatequistas;
    },
    getTodosPadres(state) {
      return state.listaPadres;
    },
    getTodasMadres(state) {
      return state.listaMadres;
    },
    getTodosPadresHijos(state) {
      return state.listaPadresHijos;
    },
    //SI es
    getTodasMadresHijos(state) {
      return state.listaMadresHijos;
    },
    getTipoPrivilegiosUsuario(state) {
      return state.tipoPrivilegiosUsuario;
    },
  },
  mutations: {
    resetValues(state) {
      state.listaColegios = undefined;
      state.listaCursosEscolares = undefined;
      state.listaPadres = undefined;
      state.listaMadres = undefined;
      state.listaCursosGruposCatequistas = undefined;
      state.listaPadresHijos = undefined;
      state.listaMadresHijos = undefined;
      state.listaCatequistasSimple = undefined;
      state.listaCursos = undefined;
      state.listaCatecumenosPadres = undefined;
      state.CursosGruposNum = undefined;
      state.datosUsuario = undefined;
      

      state.litaCursosCatequesis = [];

      state.privilegiosUsuario = [];
      state.tipoPrivilegiosUsuario = undefined;
    },
    cargaCatequistasSimple(state, data) {
      if (data) {
        state.listaCatequistasSimple = data.data.catequistas;
      } else {
        axios({
          method: "GET",
          url: `/gestionCatequesis/todosCatequistasSimple`,
          withCredentials: true,
        })
          .then((data) => {
            state.listaCatequistasSimple = data.data.catequistas;
            
          })
          .catch(() => {
            
          });
      }
    },
    cargarCatecumenosPadres(state, data) {
      if (data) {
        state.listaCatecumenosPadres = data.catecumenos;
      } else {
        axios({
          method: "GET",
          url: `/catecumenos/todosCatecumenosPadres`,
          withCredentials: true,
        })
          .then((data) => {
            state.listaCatecumenosPadres = data.data.catecumenos;
            
          })
          .catch(() => {
            
          });
      }
    },
    cargarColegiosCursos(state, request) {
      if (request && request.data) {
        if (request.data.colegios) {
          state.listaColegios = request.data.colegios.sort((a, b) =>
            a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase())
          );
        }
        if (request.data.cursos) {
          state.listaCursosEscolares = datos.cursos.sort((a, b) =>
            a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase())
          );
        }
      } else {
        axios({
          method: "GET",
          url: `/colegios/todosColegiosCursos`,
          withCredentials: true,
        })
          .then((request) => {
            state.listaColegios = request.data.colegios.sort((a, b) =>
              a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase())
            );
            state.listaCursosEscolares = request.data.cursos.sort((a, b) =>
              a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase())
            );
            
          })
          .catch(() => {
            
          });
      }
    },
    cargarPadres(state, datos) {
      if (datos) {
        state.listaPadresHijos = datos.data.padres;
        state.listaPadres = datos.data.padres.map((element) => {
          return {
            id: element.id,
            nombre: element.nombre,
            apellido1: element.apellido1,
            apellido2: element.apellido2,
            fecha_nacimiento: element.fecha_nacimiento,
            profesion: element.profesion,
            telefono: element.telefono,
          };
        });
      } else {
        axios({
          method: "GET",
          url: `/padres/todosPadresHijos`,
          withCredentials: true,
        })
          .then((request) => {
            state.listaPadres = request.data.padres.map((element) => {
              return {
                id: element.id,
                nombre: element.nombre,
                apellido1: element.apellido1,
                apellido2: element.apellido2,
                fecha_nacimiento: element.fecha_nacimiento,
                profesion: element.profesion,
                telefono: element.telefono,
              };
            });
            //Se comenta porque no se utiliza
            state.listaPadresHijos = request.data.padres;
            
          })
          .catch(() => {
            
          });
      }
    },
    cargarMadres(state, datos) {
      if (datos) {
        state.listaMadresHijos = datos.data.madres;
        state.listaMadres = datos.data.madres.map((element) => {
          return {
            id: element.id,
            nombre: element.nombre,
            apellido1: element.apellido1,
            apellido2: element.apellido2,
            fecha_nacimiento: element.fecha_nacimiento,
            profesion: element.profesion,
            telefono: element.telefono,
          };
        });
      } else {
        axios({
          method: "GET",
          url: `/padres/todasMadresHijos`,
          withCredentials: true,
        })
          .then((request) => {
            state.listaMadresHijos = request.data.madres;
            state.listaMadres = request.data.madres.map((element) => {
              return {
                id: element.id,
                nombre: element.nombre,
                apellido1: element.apellido1,
                apellido2: element.apellido2,
                fecha_nacimiento: element.fecha_nacimiento,
                profesion: element.profesion,
                telefono: element.telefono,
              };
            });
            
          })
          .catch(() => {
            
          });
      }
    },
    cargarCursosGruposCatequistas(state, data) {
      state.listaCursosGruposCatequistas = [];
      state.listaCursos = [];
      if (data) {
        state.listaCursosGruposCatequistas = data.cursos;
        state.listaCursos = data.cursos.map((element) => {
          return {
            id: element.id,
            nombre: element.nombre,
          };
        });
      } else {
        axios({
          method: "GET",
          url: `/gestionCatequesis/todosCursosSubgruposCatequistas`,
          withCredentials: true,
        })
          .then((request) => {
            state.listaCursosGruposCatequistas = request.data.cursos;
            state.listaCursos = request.data.cursos.map((element) => {
              return {
                id: element.id,
                nombre: element.nombre,
              };
            });
            
          })
          .catch(() => {
            
          });
      }
    },
    cargaCursoSubgrupos(state, idCurso) {
      axios({
        method: "GET",
        url: `/gestionCatequesis/cursoSubgruposCatequistas?idCurso=${idCurso}`,
        withCredentials: true,
      })
        .then((data) => {
          state.litaCursosCatequesis.push(data.data);
          
        })
        .catch(() => {
          
        });
    },
    cargarCountCursosGrupos(state) {
      axios({
        method: "GET",
        url: `/cursoCatequesis/recuentoCursosGrupos`,
        headers: { Accept: "application/json" },
        withCredentials: true,
      })
        .then((request) => {
          state.CursosGruposNum = request.data.cursos.map((element) => {
            var ninosCount = 0;
            element.grupos.forEach((elementGrupos) => {
              ninosCount += elementGrupos.catecumenos_count;
            });
            return {
              id: element.id,
              nombre: element.nombre,
              grupos_count: element.grupos_count,
              responsables: element.responsables.map((element2) => {
                return {
                  nombre:
                    element2.nombre +
                    " " +
                    element2.apellido1 +
                    " " +
                    element2.apellido2,
                  id: element2.id,
                };
              }),
              num_ninos: ninosCount,
              grupos: element.grupos,
            };
          });
          
        })
        .catch(() => {
          
        });
    },
    cargaPrivilegios(state, privilegios) {
      state.privilegiosUsuario = [];
      if (privilegios != "SU") {
        var list = privilegios.split("/");
        state.privilegiosUsuario = list.map((element) => {
          var privilegio = element.split("_");
          return {
            agrupacion: privilegio[0].split("|")[0],
            valor: privilegio[0].split("|")[1],
            privilegio: privilegio[1],
          };
        });
      } else {
        state.privilegiosUsuario.push("SU");
      }
      if (Array.isArray(state.privilegiosUsuario)) {
        let data = state.privilegiosUsuario;
        for (var a = 0; a < data.length; a++) {
          if (data[a] == "SU") {
            state.tipoPrivilegiosUsuario = "SU";
            break;
          } else if (data[a].agrupacion == "C") {
            state.tipoPrivilegiosUsuario = "C";
            break;
          } else if (data[a].agrupacion == "G") {
            state.tipoPrivilegiosUsuario = "G";
          }
        }
      }
    },
    cargaDatosUsuario(state) {
      axios({
        method: "GET",
        url: `/userProfile`,
        withCredentials: true,
      })
        .then((request) => {
          state.datosUsuario = request.data.userData;
          this.commit("cargaPrivilegios", request.data.userData.privilegios);
          
        })
        .catch(() => {
          alert("ERROR DE INICIO");
          
        });
    },
  },
  actions: {
    cargaPrivilegiosUsuario(context, privilegios) {
      context.commit("cargaDatosUsuario", privilegios);
    },
    cargarCountCursosGrupos(context, privilegios) {
      context.commit("cargarCountCursosGrupos", privilegios);
    },
    cargarCursosGruposCatequistas(context, data) {
      context.commit("cargarCursosGruposCatequistas", data);
    },
    cargaCatequistasSimple(context, data) {
      context.commit("cargaCatequistasSimple", data);
    },

    recargaColegiosCursos(context, data) {
      context.commit("cargarColegiosCursos", data);
    },
    recargaPadres(context, data) {
      context.commit("cargarPadres", data);
    },
    recargaMadres(context, data) {
      context.commit("cargarMadres", data);
    },
    recargaCatecumenosPadres(context, data) {
      context.commit("cargarCatecumenosPadres", data);
    },
  },
});
